import { StakeholderReference } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type SonarStakeholdersIdMapState = SyncState<Record<number, StakeholderReference>>;

export const defaultStakeholdersIdMapState: SonarStakeholdersIdMapState = { data: {} };
